import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const DoorCodesToggle = ({ paused }) => {
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const toggle = async (on) => {
    setBusy(true);
    try {
      await api.put("/admin/door-codes", { paused: !on });
      toast.success(on ? "Door codes resumed — bookings made while paused are getting their codes now" : "Door codes paused — new bookings won't get a code");
      qc.invalidateQueries({ queryKey: ["tuya-devices"] });
      qc.invalidateQueries({ queryKey: ["admin-bookings"] });
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <label className={`flex items-center gap-3 rounded-full border px-4 py-2 ${paused ? "border-amber-400/40 bg-amber-400/5" : "border-white/10"}`} data-testid="door-codes-toggle">
      <KeyRound size={14} className={paused ? "text-amber-400" : "text-[#D4AF37]"} />
      <span className="text-sm text-white">Automatic door codes</span>
      <span className={`text-[10px] uppercase font-mono-label ${paused ? "text-amber-400" : "text-green-400"}`} data-testid="door-codes-status">{paused ? "Paused" : "On"}</span>
      <Switch checked={!paused} disabled={busy} onCheckedChange={toggle} data-testid="door-codes-switch" />
    </label>
  );
};
